import { searchProduct } from 'odooApi/product';
import formInputsTypes from '../simulatorConstant';
export const TOILE_STORE_BANNE = 5379;
export const FIXATION_ATTRIBUTE = 26;

import droite from 'assets/img/stock/store/Droite.jpg';

import gauche from 'assets/img/stock/store/Gauche.jpg';

import DicksonToile from 'assets/img/dickson-toile.png';
import LamrequinDroite from 'assets/img/lambrequin-droite.png';
import LambrequinEnroulable from 'assets/img/lambrequin-enroulable.png';
import LambrequinOndulee from 'assets/img/lambrequin-ondulee.png';
import LambrequinVagues from 'assets/img/lambrequin-vagues.png';
import LatimToile from 'assets/img/latim-toile.png';
import SansLambrequin from 'assets/img/sans-lambrequin.png';
import SauledaToile from 'assets/img/sauleda-toile.png';
import manivelles from 'assets/img/stock/store/manivelle.jpg';

import CoutureSimple from 'assets/img/couture-simple.png';
import Fourreau20mm from 'assets/img/fourreau-20mm.png';
import Fourreau30mm from 'assets/img/fourreau-30mm.png';
import Fourreau40mm from 'assets/img/fourreau-40mm.png';
import Fourreau50mm from 'assets/img/fourreau-50mm.png';
import Fourreau70mm from 'assets/img/fourreau-70mm.png';
import Fourreau80mm from 'assets/img/fourreau-80mm.png';
import Fourreau90mm from 'assets/img/fourreau-90mm.png';
import Jonc3mm from 'assets/img/jonc-3mm.png';
import Jonc4mm from 'assets/img/jonc-4mm.png';
import Jonc55mm from 'assets/img/jonc-5.5mm.png';
import Jonc5mm from 'assets/img/jonc-5mm.png';
import Jonc6mm from 'assets/img/jonc-6mm.png';
import Jonc7mm from 'assets/img/jonc-7mm.png';
import Jonc8mm from 'assets/img/jonc-8mm.png';

import StoreDemiCoffre from 'assets/img/store-demi-coffre.png';

import StoreCoffre from 'assets/img/store-demi-coffre.png';
import StoreMonobloc from 'assets/img/store-monobloc.png';

import StoreBanneToile from 'assets/img/store-banne-toile.png';
import StoreBrasDroits from 'assets/img/store-bras-droite.png';
import StoreDecenteVertical from 'assets/img/store-descente-verticale.png';
import StoreDoublePente from 'assets/img/store-double-pente.png';

import ManoeuvreElectrique from 'assets/img/manoeuvre-electrique.png';
import ManoeuvreManuel from 'assets/img/manoeuvre-manuel.png';
import Filaire from 'assets/img/stock/Filaire.png';
import Radio from 'assets/img/stock/Radio.png';
import Solaire from 'assets/img/stock/Solaire.png';

import StoreCapteurVent from 'assets/img/store-capteur-vent.png';
import StoreSansCapteurVent from 'assets/img/store-sans-capteur-vent.png';

export const capteur = {
	id: 'capteur_vent',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Capteur de vent',
	name: 'capteur_vent',
	nextStepData: false,
	nextStep: false,
	options: null,

	fetchData: (currentFormValue, fnSuccess) => {
		let data = '';
		const generateDescription = (data) => {
			return ` ${
				currentFormValue?.StoreBanneData ? `` + currentFormValue?.StoreBanneData?.value : ''
			} ${
				currentFormValue?.manoeuvre_store
					? ` ` + currentFormValue?.manoeuvre_store?.value + ' complet'
					: ''
			} ${
				currentFormValue?.TypeStorebanne
					? ` \n - Store banne ` + currentFormValue?.TypeStorebanne?.label
					: ''
			} ${
				currentFormValue?.ToileStoreBanneData
					? ` \n - Toile ` + currentFormValue?.ToileStoreBanneData?.label
					: ''
			}${
				currentFormValue?.TypetoileStorebanne
					? ` \n - ` + currentFormValue?.TypetoileStorebanne?.label
					: ''
			} ${
				currentFormValue?.largeurToile
					? ` \n - Largeur de store banne ` + currentFormValue?.largeurToile + ' (mm)'
					: ''
			} ${
				currentFormValue?.projection
					? ` \n - Projection ` + currentFormValue?.projection
					: ''
			} ${
				currentFormValue?.avancee ? `\n - Avancée ` + currentFormValue?.avancee?.label : ''
			} ${
				currentFormValue?.cache
					? `\n - Couleur des caches en plastique ` + currentFormValue?.cache?.label
					: ''
			} ${
				currentFormValue?.fixation_haute
					? `\n - Fixation haute ` + currentFormValue?.fixation_haute?.label
					: ''
			} ${
				currentFormValue?.fixation_basse
					? `\n - Fixation basse ` + currentFormValue?.fixation_basse?.label
					: ''
			} ${
				currentFormValue?.type_fixation
					? `\n - Fixation ` + currentFormValue?.type_fixation?.value
					: ''
			} ${data ? `\n - ` + data : ''} ${
				currentFormValue?.lambrequin ? `\n - ` + currentFormValue?.lambrequin?.value : ''
			} ${
				currentFormValue?.remplacement_telecommande?.id == 'oui_telecommande'
					? `\n - Avec télécommande `
					: ''
			} ${
				currentFormValue?.telecommande
					? `\n - ` + currentFormValue?.telecommande?.value
					: ''
			} ${
				currentFormValue?.sortie
					? `\n - Sortie électrique ` + currentFormValue?.sortie?.value
					: ''
			} 
             `;
		};
		const options = [
			{
				id: 'avec',
				label: 'Avec capteur de vent',
				value: 'Avec capteur de vent',
				imageUrl: StoreCapteurVent,
				product_id: currentFormValue?.StoreBanneData?.id,
				description: generateDescription((data = 'Avec capteur de vent')),
				nextStep: false,
			},
			{
				id: 'sans',
				label: 'Sans capteur de vent',
				value: 'Sans capteur de vent',
				imageUrl: StoreSansCapteurVent,
				product_id: currentFormValue?.StoreBanneData?.id,
				description: generateDescription((data = 'Sans capteur de vent')),
				nextStep: false,
			},
		];

		fnSuccess(options);
	},
};

export const sortie = {
	id: 'sortie',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Sortie électrique (vue en face)',
	name: 'sortie',
	nextStepData: capteur,
	classGroup: 'SProduit',
	nextStep: false,
	options: [
		{
			id: 'gauche',
			label: '',
			value: 'gauche',
			imageUrl: gauche,
			nextStep: false,
		},
		{
			id: 'droite',
			label: '',
			value: 'droite',
			imageUrl: droite,
			nextStep: false,
		},
	],
};

export const telecommande = {
	id: 'telecommande',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Type de motorisation',
	name: 'telecommande',
	nextStepData: sortie,
	nextStep: false,
	options: [
		{
			id: 'motorisation_radio',
			// label: "Radio",
			value: 'Motorisation radio',
			imageUrl: Radio,
			nextStep: false,
		},
		{
			id: 'motorisation_filaire',
			//  label: "Filaire",
			value: 'Motorisation filaire',
			imageUrl: Filaire,
			nextStep: false,
		},
		{
			id: 'motorisation_solaire',
			// label: "Solaire",
			value: 'Motorisation solaire',
			imageUrl: Solaire,
			nextStep: false,
		},
	],
};

export const type_fixation = {
	id: 'type_fixation',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Type de fixation',
	name: 'type_fixation',
	nextStepData: capteur,
	nextStep: false,
	options: [
		{
			id: 'murale',
			label: 'Murale',
			value: 'murale',
			nextStep: false,
		},
		{
			id: 'plafond',
			label: 'Plafond',
			value: 'plafond',
			nextStep: false,
		},
		{
			id: 'entre_murs',
			label: 'Entre murs',
			value: 'entre murs',
			nextStep: false,
		},
	],
};
export const remplacement_telecommande = {
	id: 'remplacement_telecommande',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Remplacement de la télécommande',
	name: 'remplacement_telecommande',
	nextStepData: false,
	nextStep: false,
	fetchData: async (currentFormValue, fnSuccess) => {
		const generateDescription = () => {
			return `${
				currentFormValue?.StoreBanneData
					? ` ` + currentFormValue?.StoreBanneData?.label
					: ''
			}
            ${
				currentFormValue?.remplacement_moteur == 'oui_moteur'
					? `\n - Remplacement moteur par ` + currentFormValue?.moteur_store_banne?.label
					: ''
			}
          `;
		};
		const options = [
			{
				id: 'oui_telecommande',
				label: 'Oui',
				value: 'oui',
				nextStep: type_fixation,
			},
			{
				id: 'non-telecommande',
				label: 'Non',
				value: 'non',

				nextStep: type_fixation,
			},
		];
		fnSuccess(options);
	},
};
export const moteur_store_banne = {
	id: 'moteur_store_banne',
	type: formInputsTypes?.SELECT_INPUT,
	label: 'Sélectionner un moteur',
	name: 'moteur_store_banne',
	nextStepData: remplacement_telecommande,
	nextStep: false,
	options: null,
	fetchData: (currentFormValue, fnSuccess) => {
		const generateFilter = (idCat) => {
			const filters = [['categ_id', '=', idCat]];

			return filters;
		};

		searchProduct(generateFilter(currentFormValue?.marqueMoteurStore?.id), ({ elements }) => {
			const options = elements?.length
				? elements.map((item) => ({
						id: item?.id,
						label: item?.display_name,
						value: item?.id,
						lst_price: item?.lst_price,
						brand_id: item?.brand_id,
				  }))
				: [];
			fnSuccess(options);
		});
	},
};
const marqueMoteurStore = {
	id: 'marqueMoteurStore',
	type: formInputsTypes?.SELECT_INPUT,
	label: 'Sélectionner la marque du moteur',
	name: 'marqueMoteurStore',
	nextStepData: moteur_store_banne,
	nextStep: false,
	options: null,
	fetchData: (currentFormValue, fnSuccess) => {
		const generateFilter = () => {
			const filters = [['parent_id', '=', CATEG_ID_MOTEURS_STORE_BANNE]];

			return filters;
		};
		searchCategory(generateFilter(currentFormValue), ({ elements }) => {
			const options = elements?.length
				? elements?.map((item) => ({
						id: item?.id,
						label: item?.name,
						value: item?.id,
						/* nextStep:item?.name=="Bubendorff"?typeMoteurBubendorff:typeMoteur */
				  }))
				: [];
			fnSuccess(options);
		});
	},
};

export const remplacement_moteur = {
	id: 'remplacement_moteur',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Remplacement un moteur',
	name: 'remplacement_moteur',
	nextStepData: false,
	nextStep: false,
	options: [
		{
			id: 'oui_moteur',
			label: 'Oui',
			value: 'oui',
			nextStep: telecommande,
		},
		{
			id: 'non_moteur',
			label: 'Non',
			value: 'non',
			nextStep: remplacement_telecommande,
		},
	],
};

export const hauteur_manivelle = {
	id: 'hauteur_manivelle_store',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Hauteur de votre manivelle',
	name: 'hauteur_manivelle_store',
	classGroup: 'SProduit',
	nextStepData: false,
	nextStep: false,
	options: null,
	fetchData: (currentFormValue, fnSuccess) => {
		let data = '';
		const generateDescription = (data) => {
			return ` ${
				currentFormValue?.StoreBanneData ? `` + currentFormValue?.StoreBanneData?.value : ''
			} ${
				currentFormValue?.manoeuvre_store
					? ` ` + currentFormValue?.manoeuvre_store?.value + ' complet'
					: ''
			} ${
				currentFormValue?.TypeStorebanne
					? ` \n - Store banne ` + currentFormValue?.TypeStorebanne?.label
					: ''
			} ${
				currentFormValue?.TypeStorebanne
					? ` \n - ` + currentFormValue?.TypeStorebanne?.label
					: ''
			} ${
				currentFormValue?.ToileStoreBanneData
					? ` \n - Toile ` + currentFormValue?.ToileStoreBanneData?.label
					: ''
			} ${
				currentFormValue?.TypetoileStorebanne
					? ` \n - ` + currentFormValue?.TypetoileStorebanne?.label
					: ''
			} ${
				currentFormValue?.largeurToile
					? ` \n - Largeur de store banne ` + currentFormValue?.largeurToile + ' (mm)'
					: ''
			} ${
				currentFormValue?.projection
					? ` \n - Projection ` + currentFormValue?.projection
					: ''
			} ${
				currentFormValue?.avancee ? `\n - Avancée ` + currentFormValue?.avancee?.label : ''
			} ${
				currentFormValue?.cache
					? `\n - Couleur des caches en plastique ` + currentFormValue?.cache?.label
					: ''
			} ${
				currentFormValue?.fixation_haute
					? `\n - Fixation haute ` + currentFormValue?.fixation_haute?.label
					: ''
			} ${
				currentFormValue?.fixation_basse
					? `\n - Fixation basse ` + currentFormValue?.fixation_basse?.label
					: ''
			} ${
				currentFormValue?.type_fixation
					? `\n - Fixation ` + currentFormValue?.type_fixation?.value
					: ''
			}  ${
				currentFormValue?.lambrequin ? `\n - ` + currentFormValue?.lambrequin?.value : ''
			} ${
				currentFormValue?.manivelle_store
					? `\n - ` + currentFormValue?.manivelle_store?.label
					: ''
			} ${data ? `\n - Hauteur de la manivelle ` + data : ''} 
             `;
		};
		const options = [
			{
				id: '50',
				label: '500 mm',
				value: '500 mm',
				product_id: currentFormValue?.StoreBanneData?.id,
				description: generateDescription((data = '500 mm')),
				imageUrl: manivelles,
				nextStep: false,
			},
			{
				id: '80',
				label: '800 mm',
				value: '800 mm',
				product_id: currentFormValue?.StoreBanneData?.id,
				description: generateDescription((data = '800 mm')),
				imageUrl: manivelles,
				nextStep: false,
			},
			{
				id: '100',
				label: '1000 mm',
				value: '1000 mm',
				product_id: currentFormValue?.StoreBanneData?.id,
				description: generateDescription((data = '1000 mm')),
				imageUrl: manivelles,
				nextStep: false,
			},
			{
				id: '120',
				label: '1200 mm',
				value: '1200 mm',
				product_id: currentFormValue?.StoreBanneData?.id,
				description: generateDescription((data = '1200 mm')),
				imageUrl: manivelles,
				nextStep: false,
			},
			{
				id: '180',
				label: '1800 mm',
				value: '1800 mm',
				product_id: currentFormValue?.StoreBanneData?.id,
				description: generateDescription((data = '1800 mm')),
				imageUrl: manivelles,
				nextStep: false,
			},
		];

		fnSuccess(options);
	},
};

export const manivelle = {
	id: 'manivelle_store',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Type de commande',
	name: 'manivelle_store',
	style: { display: 'none' },
	nextStepData: false,
	nextStep: false,
	options: [
		{
			id: 'Manivelle',
			label: 'Manuelle à manivelle',
			value: 'Manuelle à manivelle',
			checked: true,
			nextStep: hauteur_manivelle,
		},
	],
};

export const manoeuvre = {
	id: 'manoeuvre_store',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Manoeuvre',
	name: 'manoeuvre_store',
	nextStepData: false,
	nextStep: false,
	options: [
		{
			id: 'manuel',
			label: 'Manuel',
			value: 'manuel',
			imageUrl: ManoeuvreManuel,

			nextStep: manivelle,
		},
		{
			id: 'electrique',
			label: 'Électrique',
			value: 'électrique',
			imageUrl: ManoeuvreElectrique,

			nextStep: telecommande,
		},
	],
};

const lambrequin = {
	id: 'lambrequin',
	type: formInputsTypes?.SELECT_INPUT,
	label: 'Lambrequin',
	name: 'lambrequin',
	nextStepData: manoeuvre,
	nextStep: false,
	options: [
		{
			id: 'sans_lambrequin',
			label: 'Sans lambrequin',
			value: 'Sans lambrequin',
			imageUrl: SansLambrequin,

			nextStep: false,
		},
		{
			id: 'coupe_droite',
			label: 'Coupe droite',
			value: 'Lambrequin coupe droite',
			imageUrl: LamrequinDroite,

			nextStep: false,
		},
		{
			id: 'coupe_ondulee',
			label: 'Coupe ondulée',
			value: 'Lambrequin coupe ondulée',
			imageUrl: LambrequinOndulee,

			nextStep: false,
		},
		{
			id: 'coupe_vagues',
			label: 'Coupe à vagues',
			value: 'Lambrequin coupe à vagues',
			imageUrl: LambrequinVagues,

			nextStep: false,
		},
		{
			id: 'lambrequin_enroulable',
			label: 'Lambrequin enroulable 150mm',
			value: 'lambrequin enroulable 150mm',
			imageUrl: LambrequinEnroulable,

			nextStep: false,
		},
	],
};

const TypetoileStorebanne = {
	id: 'T_Store',
	type: formInputsTypes?.SELECT_INPUT,
	label: 'Type de la toile',
	name: 'TypetoileStorebanne',
	nextStepData: lambrequin,
	nextStep: false,
	options: [
		{
			id: 'TSB1',
			label: 'Toile de store banne',
			value: 'Toile de store banne',
			imageUrl: StoreBanneToile,

			nextStep: false,
		},
		{
			id: 'TSBD1',
			label: 'Toile de store bras droits',
			value: 'Toile de store bras droits',
			imageUrl: StoreBrasDroits,

			nextStep: false,
		},
		{
			id: 'TSBD1',
			label: 'Toile store double pente',
			value: 'Toile store double pente',
			imageUrl: StoreDoublePente,

			nextStep: false,
		},
		{
			id: 'TSBD1',
			label: 'Toile de store à descente verticale',
			value: 'Toile de store à descente verticale',
			imageUrl: StoreDecenteVertical,

			nextStep: false,
		},
	],
};

const ToileStoreBanneData = {
	id: 'T_Store',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Sélectionner une toile',
	name: 'T_Store',
	nextStepData: TypetoileStorebanne,
	nextStep: false,
	options: null,
	fetchData: (currentFormValue, fnSuccess) => {
		const elements = [
			{
				id: 11273,
				name: 'Toile',
				display_name: 'Toile (Dickson)',
				default_code: '',
				description: '',
				list_price: 1.0,
				lst_price: 1.0,
				product_tmpl_id: 5379,
				type: 'product',
				categ_id: {
					id: 200,
					name: 'Store banne',
				},
				weight: 0.0,
				product_template_attribute_value_ids: [
					{
						id: 973,
						name: 'Dickson',
					},
				],
				brand_id: {
					id: '',
					name: '',
				},
				diametre: 0,
				active: true,
				Taille: 0,
				standard_price: 0.0,
				taxes_id: [
					{
						id: 1,
						name: '20,0%',
					},
				],
				supplier_taxes_id: [
					{
						id: 19,
						name: '20%',
					},
				],
				description_sale: '',
			},
			{
				id: 11275,
				name: 'Toile',
				display_name: 'Toile (Sauleda)',
				default_code: '',
				description: '',
				list_price: 1.0,
				lst_price: 1.0,
				product_tmpl_id: 5379,
				type: 'product',
				categ_id: {
					id: 200,
					name: 'Store banne',
				},
				weight: 0.0,
				product_template_attribute_value_ids: [
					{
						id: 975,
						name: 'Sauleda',
					},
				],
				brand_id: {
					id: '',
					name: '',
				},
				diametre: 0,
				active: true,
				Taille: 0,
				standard_price: 0.0,
				taxes_id: [
					{
						id: 1,
						name: '20,0%',
					},
				],
				supplier_taxes_id: [
					{
						id: 19,
						name: '20%',
					},
				],
				description_sale: '',
			},
			{
				id: 11278,
				name: 'Toile',
				display_name: 'Toile (Latim)',
				default_code: '',
				description: '',
				list_price: 1.0,
				lst_price: 1.0,
				product_tmpl_id: 5379,
				type: 'product',
				categ_id: {
					id: 200,
					name: 'Store banne',
				},
				weight: 0.0,
				product_template_attribute_value_ids: [
					{
						id: 978,
						name: 'Latim',
					},
				],
				brand_id: {
					id: '',
					name: '',
				},
				diametre: 0,
				active: true,
				Taille: 0,
				standard_price: 0.0,
				taxes_id: [
					{
						id: 1,
						name: '20,0%',
					},
				],
				supplier_taxes_id: [
					{
						id: 19,
						name: '20%',
					},
				],
				description_sale: '',
			},
		];

		const options = !!elements?.length
			? elements.map((item) => {
					const { product_template_attribute_value_ids } = item;
					let name = item?.display_name + ' ';
					product_template_attribute_value_ids.map((i) => (name += i.name + ' '));
					return {
						id: item?.id,
						label: name,
						value: item?.id,
						imageUrl:
							item?.id == 11273
								? DicksonToile
								: item?.id == 11275
								? SauledaToile
								: item?.id == 11278
								? LatimToile
								: null,
					};
			  })
			: [];
		fnSuccess(options);
	},
};

const fixation_basse = {
	id: 'fixation_basse',
	type: formInputsTypes?.SELECT_INPUT,
	label: 'Fixation basse',
	name: 'fixation_basse',
	nextStepData: ToileStoreBanneData,
	nextStep: false,
	options: null,
	fetchData: (currentFormValue, fnSuccess) => {
		const value_ids = [
			{
				id: 202,
				name: 'Couture simple',
			},
			{
				id: 203,
				name: 'Jonc 3mm inclus',
			},
			{
				id: 204,
				name: 'Jonc 4mm inclus',
			},
			{
				id: 205,
				name: 'Jonc 5mm inclus',
			},
			{
				id: 206,
				name: 'Jonc 5.5mm inclus',
			},
			{
				id: 207,
				name: 'Jonc 6mm inclus',
			},
			{
				id: 208,
				name: 'Jonc 7mm inclus',
			},
			{
				id: 209,
				name: 'Jonc 8mm inclus',
			},
			{
				id: 210,
				name: 'Fourreau pour tube 20mm',
			},
			{
				id: 211,
				name: 'Fourreau pour tube 30mm',
			},
			{
				id: 212,
				name: 'Fourreau pour tube 40mm',
			},
			{
				id: 213,
				name: 'Fourreau pour tube 50mm',
			},
			{
				id: 214,
				name: 'Fourreau pour tube 70mm',
			},
			{
				id: 215,
				name: 'Fourreau pour tube 80mm',
			},
			{
				id: 216,
				name: 'Fourreau pour tube 90mm',
			},
		];
		const options = value_ids?.length
			? value_ids?.map((item) => ({
					id: item?.id,
					// label: item?.name,
					value: item?.id,
					imageUrl: (() => {
						switch (item?.id) {
							case 202:
								return CoutureSimple;
							case 203:
								return Jonc3mm;
							case 204:
								return Jonc4mm;
							case 205:
								return Jonc5mm;
							case 206:
								return Jonc55mm;
							case 207:
								return Jonc6mm;
							case 208:
								return Jonc7mm;
							case 209:
								return Jonc8mm;
							case 210:
								return Fourreau20mm;
							case 211:
								return Fourreau30mm;
							case 212:
								return Fourreau40mm;
							case 213:
								return Fourreau50mm;
							case 214:
								return Fourreau70mm;
							case 215:
								return Fourreau80mm;
							case 216:
								return Fourreau90mm;
							default:
								return null;
						}
					})(),
			  }))
			: [];
		fnSuccess(options);
	},
};

const fixation_haute = {
	id: 'fixation_haute',
	type: formInputsTypes?.SELECT_INPUT,
	label: 'Fixation haute',
	name: 'fixation_haute',
	nextStepData: fixation_basse,
	nextStep: false,
	options: null,
	fetchData: (currentFormValue, fnSuccess) => {
		const value_ids = [
			{
				id: 202,
				name: 'Couture simple',
			},
			{
				id: 203,
				name: 'Jonc 3mm inclus',
			},
			{
				id: 204,
				name: 'Jonc 4mm inclus',
			},
			{
				id: 205,
				name: 'Jonc 5mm inclus',
			},
			{
				id: 206,
				name: 'Jonc 5.5mm inclus',
			},
			{
				id: 207,
				name: 'Jonc 6mm inclus',
			},
			{
				id: 208,
				name: 'Jonc 7mm inclus',
			},
			{
				id: 209,
				name: 'Jonc 8mm inclus',
			},
			{
				id: 210,
				name: 'Fourreau pour tube 20mm',
			},
			{
				id: 211,
				name: 'Fourreau pour tube 30mm',
			},
			{
				id: 212,
				name: 'Fourreau pour tube 40mm',
			},
			{
				id: 213,
				name: 'Fourreau pour tube 50mm',
			},
			{
				id: 214,
				name: 'Fourreau pour tube 70mm',
			},
			{
				id: 215,
				name: 'Fourreau pour tube 80mm',
			},
			{
				id: 216,
				name: 'Fourreau pour tube 90mm',
			},
		];
		const options = !!value_ids?.length
			? value_ids?.map((item) => ({
					id: item?.id,
					// label: item?.name,
					value: item?.id,
					imageUrl: (() => {
						switch (item?.id) {
							case 202:
								return CoutureSimple;
							case 203:
								return Jonc3mm;
							case 204:
								return Jonc4mm;
							case 205:
								return Jonc5mm;
							case 206:
								return Jonc55mm;
							case 207:
								return Jonc6mm;
							case 208:
								return Jonc7mm;
							case 209:
								return Jonc8mm;
							case 210:
								return Fourreau20mm;
							case 211:
								return Fourreau30mm;
							case 212:
								return Fourreau40mm;
							case 213:
								return Fourreau50mm;
							case 214:
								return Fourreau70mm;
							case 215:
								return Fourreau80mm;
							case 216:
								return Fourreau90mm;
							default:
								return null;
						}
					})(),
			  }))
			: [];
		fnSuccess(options);
	},
};

const cache = {
	id: 'cache',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Couleur des caches en plastique',
	name: 'cache',
	className: 'col-12',
	nextStep: fixation_haute,
	options: [
		{
			id: 'blanc',
			label: 'blanc',
			value: 'blanc',
			nextStep: fixation_haute,
		},
		{
			id: 'noir',
			label: 'noir',
			value: 'noir',
			nextStep: fixation_haute,
		},
	],
};

const avancee = {
	id: 'avancee',
	type: formInputsTypes?.RADIO_INPUT,
	label: "L'avancée de store banne",
	name: 'avancee',
	nextStepData: fixation_haute,
	//nextStep: fixation_haute,
	options: [
		{
			id: '150',
			label: '1500 mm',
			value: '1500 mm',
			nextStep: fixation_haute,
		},
		{
			id: '175',
			label: '1750 mm',
			value: '1750 mm',
			nextStep: fixation_haute,
		},
		{
			id: '200',
			label: '2000 mm',
			value: '2000 mm',
			nextStep: fixation_haute,
		},
		{
			id: '225',
			label: '2250 mm',
			value: '2250 mm',
			nextStep: fixation_haute,
		},
		{
			id: '250',
			label: '2500 mm',
			value: '2500 mm',
			nextStep: fixation_haute,
		},
		{
			id: '300',
			label: '3000 mm',
			value: '3000 mm',
			nextStep: fixation_haute,
		},
		{
			id: '350',
			label: '3500 mm',
			value: '3500 mm',
			nextStep: fixation_haute,
		},
	],
};

const largeurStorebanne = {
	id: 'L-TOILE',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'largeurToile',
	className: 'col-6',
	label: 'Largeur de store banne(mm)',
	nextStepData: avancee,
	nextStep: false,
	validation: (value) => {
		return value > 0;
	},
};

const TypeStorebanne = {
	id: 'T_Store',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Type de store banne',
	name: 'TypeStorebanne',
	nextStepData: largeurStorebanne,
	nextStep: false,
	options: [
		{
			id: 'TSB3',
			label: 'Monobloc (sans coffre)',
			value: 'Monobloc',
			imageUrl: StoreMonobloc,
			nextStep: false,
		},
		{
			id: 'TSB2',
			label: 'Coffre',
			value: 'Coffre',
			imageUrl: StoreCoffre,
			nextStep: false,
		},
		{
			id: 'TSB1',
			label: 'Semi coffre',
			value: 'Semi coffre',
			imageUrl: StoreDemiCoffre,
			nextStep: false,
		},
	],
};

export default TypeStorebanne;
